import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  Grid2,
  Link,
  Stack,
  TextField,
  InputLabel,
  Typography,
  MenuItem,
  FormControl,
  Select,
  FormHelperText,
  Modal,
  FormLabel,
  Checkbox,
  Autocomplete,
  Avatar
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { createOrganization, createOrganizationForSnapshot, fetchOrganizationByName } from "../apis/apiList/organizationApi";
import { getFollowUpTeamMember } from "../apis/apiList/userApi";
import { useMessage } from "../context/MessageContext";
import { useApp } from "../context/AppContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { data } from "jquery";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


const subscriberTypeList = [
  // { id: 1, type: "Subscriber", value: "subscriber" },
  // { id: 2, type: "Demo", value: "demo" },
  // { id: 3, type: "Per-project", value: "per-project" },
  // { id: 4, type: "Prospects", value: "prospects" },
  // { id: 5, type: "Leads", value: "leads" },
  // { id: 6, type: "Subscriber - Canceled", value: "subscriber-canceled" },
  { id: 1, type: "Full Automated", value: "automated" },
  { id: 2, type: "Assisted", value: "assisted" },
  
];

const industries = [
  "Healthcare and Social Assistance",
  "Technology (Information Technology)",
  "Finance and Insurance",
  "Retail Trade",
  "Construction",
  "Manufacturing",
  "Professional and Business Services",
  "Real Estate, Rental, and Leasing",
  "Education Services",
  "Transportation and Warehousing",
  "Energy (Utilities and Renewables)",
  "Telecommunications",
  "Agriculture and Forestry",
  "Hospitality and Tourism",
  "Aerospace and Defense",
  "Entertainment and Media",
  "Food and Beverage Industry",
  "Pharmaceuticals and Biotechnology",
  "Automotive",
  "Others",
];

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const validationSchema = Yup.object().shape({
  organizationName: Yup.string().required("Organization name is required"),
  zip: Yup.string().required("Zip is required"),
  phone: Yup.string()
    // .matches(/^\d+$/, "Phone must be numbers only")
    .required("Phone is required"),
  // purchaseDate: Yup.date().required("Purchase Date is required"),
  // .max(new Date(), "Purchase Date cannot be in the future"),
  // videoPackage: Yup.number()
  //   .required("Video package is required")
  //   .integer("Must be a whole number")
  //   .positive("Must be a positive number")
  //   .typeError("Must be a number"),
  subscriberType: Yup.string().required("Subscriber Type is required"),
  // industry: Yup.string().required("Industry is required"),
});
const followUpValidation = Yup.object().shape({
  selectTeamMember: Yup.string().required("Please select team member"),
  startDate: Yup.date().required("Follow Up Date is required"),
});

const style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  //   p: 4,
};

const CustomButton = ({ value, onClick }) => (
  <Stack direction={"row"} alignItems={"center"}>
    <Button onClick={onClick}>
      <img
        src={"/images/due-date.png"}
        style={{ width: "40px", height: "40px" }}
      />
    </Button>
    <Typography variant="h3">{value}</Typography>
  </Stack>
);

const usStates = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
  "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
  "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
  "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
  "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
  "Wisconsin", "Wyoming"
];

function CreateOrganization() {
    const [organizationOptions, setOrganizationOptions] = useState([]);
  const [loading, setLoading] = useState(false);
    const { userDetails } = useApp();
  const [followUpTeam, setFollowUpTeam] = useState([]);
  const { showMessage } = useMessage();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingFollowUp, setIsSubmittingFollowUp] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedTaskDetails, setSelectedTaskDetails] = useState({});
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [isSelectedOrg, setIsSelectedOrg] = useState(false);
  const navigate = useNavigate();
  const [selectedOptionOrg, setSelectedOptionOrg] = useState({});
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [orgUserList, setOrgUserList] = useState([]);

  useEffect(() => {
    async function fetchTeamMember() {
      try {
        const users = await getFollowUpTeamMember();
        console.log("users", users);
        if (users) {
          setFollowUpTeam(users.data);
        }
      } catch (error) {
        console.log("error", error);
      }
    }
    fetchTeamMember();
  }, []);

   // Function to fetch organization data
   const fetchOrganizations = async (query) => {
    if (!query) {
      setOrganizationOptions([]); // Clear suggestions if input is empty
      return;
    }

    setLoading(true);
    try {
    //   const response = await fetchOrganizationByName(query)
      console.log('query', query)
      const response = await axios.get(`${process.env.REACT_APP_VPMA_BACKEND_URL}/snapshotvideos/get/identical/organization/${query}`)
      console.log('response', response)
      setOrganizationOptions([...response.data.organizations]);
    } catch (error) {
      console.error("Error fetching organizations:", error);
      setOrganizationOptions([]); // Clear options on error
    }
    setLoading(false);
  };

  // useEffect(()=>{
    const fetchVpmaOrganizationUsers = async (orgId) =>{      
      try {

        const response = await axios.get(`${process.env.REACT_APP_VPMA_BACKEND_URL}/snapshotvideos/user/fetch/by/org/${orgId}`)
        console.log('response setOrgUserList', response)
        setOrgUserList([...response.data.data]);
      } catch (error) {
        console.error("Error fetching organizations:", error);
        setOrgUserList([]); // Clear options on error
      }
    }

  //   if(isSelectedOrg) {
  //     fetchVpmaOrganizationUsers();
  //   }
  // }, [isSelectedOrg])

  const handleSubmit = async (values) => {
    console.log("values", values);

    // let taskData = {}
    // let isTaskCreated = false
    // console.log('selectedUser', selectedUser)
    // if(Object.keys(selectedUser).length !== 0) {
    //     isTaskCreated = true
    //     taskData.teammember = `${selectedUser.firstName} ${selectedUser.lastName}`
    //     taskData.tduedate = selectedTaskDetails.startDate
    //     taskData.assignedByUserId = userDetails._id
    //     taskData.assignToUserid =selectedTaskDetails.selectTeamMember
    // }
    try {
      // const data = {
      //   orgLogo: values.orgLogo,
      //   subscriber: values.subscriberType == "subscriber" ? "yes" : "no",
      //   ...values,
      //   ...taskData,
      //   isTaskCreated: isTaskCreated
      // };
      const formData = new FormData();
      // formData.append("orgLogo", values.orgLogo);
      // const subscriber = values.subscriberType === "subscriber" ? "yes" : "no";
      // console.log('subscriber', subscriber)
      // formData.append(
      //   "subscriber",
      //   subscriber
      // );
      formData.append( "isSelectedOrg", true );

      Object.keys(values).forEach((key) => {
        if (values[key] !== null && values[key] !== undefined) {
          formData.append(key, values[key]);
        }
      });

      // Handle taskData
      if (Object.keys(selectedUser).length !== 0) {
        formData.append(
          "teammember",
          `${selectedUser.firstName} ${selectedUser.lastName}`
        );
        formData.append("tduedate", selectedTaskDetails.startDate);
        formData.append("assignedByUserId", userDetails._id);
        formData.append("assignToUserid", selectedTaskDetails.selectTeamMember);
        formData.append("isTaskCreated", true);
      } else {
        formData.append("isTaskCreated", false);
      }
      console.log("data create org", data);
      if(isSelectedOrg){
        console.log('isSelectedOrg if', isSelectedOrg)
        console.log('selectedOptionOrg if', selectedOptionOrg)
        formData.append( "vpmaOrgId", selectedOptionOrg._id );
        formData.append( "freshbook_profile_id", selectedOptionOrg.freshbook_profile_id );
        formData.append( "vimeo_uri", selectedOptionOrg.vimeo_uri);
        formData.append( "boxfolderid", selectedOptionOrg.boxfolderid );
        formData.append( "selectedUserList", JSON.stringify(selectedUsers) );
        
        const orgData = await createOrganizationForSnapshot(formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log("organization orgData", orgData);

        navigate(`/org/${orgData.data._id}/projects`);
        setIsSubmitting(false);
        showMessage("Organization created successfully", "success");

      } else {
        console.log('isSelectedOrg else ', isSelectedOrg)
        const orgData = await createOrganization(formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log("organization orgData", orgData);
        navigate(`/org/${orgData.data._id}/projects`);
        setIsSubmitting(false);
        showMessage("Organization created successfully", "success");
      }
      
    } catch (err) {
      console.log("err ", err);
      setIsSubmitting(false);
      showMessage(
        err?.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  const handleFollowUpTask = (values) => {
    console.log("values", values);
    console.log("followUpTeam", followUpTeam);
    // const selectedUser = followUpTeam.filter((user)=>user._id == values.selectTeamMember);
    const selectedUser = followUpTeam.find((user) => user._id == values.selectTeamMember);
    console.log("selectedUser", selectedUser);
    setSelectedUser(selectedUser);
    setSelectedTaskDetails(values);
    setOpen(false)
  };

  return (
    <div>
      <Stack
        backgroundColor="#495967"
        py={2}
        px={4}
        direction={"row"}
        justifyContent={"space-between"}
      >
        <Typography variant="h2" color="#fff">
          Create Organization
        </Typography>
        <Button
          variant="contained"
          backgroundColor={"primary"}
          onClick={handleOpen}
        >
          Create Task
        </Button>
      </Stack>
      <Box backgroundColor="rgb(28, 47, 65)" p={4}>
        <Box p={4} backgroundColor="#fff" borderRadius={1}>
          <Formik
            initialValues={{
              organizationName: "",
              street: "",
              city: "",
              state: "",
              zip: "",
              phone: "",
              twitter: "",
              linkedIn: "",
              orgLogo: null,
              subscriberType: "",
              fiscalYear: "",
              industry: "",
              otherIndustry: "",
              nickName: "",
              website: "",
              // purchaseDate: "",
              // videoPackage: "",
              notes: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              console.log("Form Data:", values);
              setIsSubmitting(true);
              // setSubmitting(false);
              handleSubmit(values);
            }}
          >
            {({
              values,
              setFieldValue,
              handleChange,
              handleBlur,
              isValid,
              errors,
              touched,
            }) => (
              <Form>
                <Grid2 container spacing={3}>
                  {/** Organization Name **/}
                  <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                    <Autocomplete
                      freeSolo
                      options={organizationOptions}
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option
                          : option.organization_name
                      }
                      // getOptionLabel={(option) =>
                      //   typeof option === "string" ? option : `( ${option.organization_name} ), ${option.street}, ${option.city}, ${option.state}, ${option.phone}`
                      // }
                      loading={loading}
                      onInputChange={(event, newInputValue) => {
                        console.log('newInputValue', newInputValue)
                        console.log('event', event)
                        fetchOrganizations(newInputValue);

                        if (!newInputValue || (selectedOptionOrg && newInputValue != selectedOptionOrg.organization_name)) {
                          setSelectedOptionOrg(null);
                          setIsSelectedOrg(false);

                          // Clear all related fields
                          setFieldValue("street", "");
                          setFieldValue("city", "");
                          setFieldValue("state", "");
                          setFieldValue("zip", "");
                          setFieldValue("phone", "");
                          setFieldValue("twitter", "");
                          setFieldValue("linkedIn", "");
                          setFieldValue("subscriber", "");
                          setFieldValue("subscriberType", "");
                          setFieldValue("fiscalYear", "");
                          setFieldValue("industry", "");
                          setFieldValue("otherIndustry", "");
                          setFieldValue("nickName", "");
                          setFieldValue("website", "");
                          setFieldValue("notes", "");
                          setOrgUserList([]);
                        }

                      }}
                      onChange={(event, selectedOption) => {

                        console.log('selectedOption', selectedOption)
                        if (selectedOption) {
                          setSelectedOptionOrg(selectedOption);
                          setIsSelectedOrg(true);
                          fetchVpmaOrganizationUsers(selectedOption._id);
                          setFieldValue(
                            "organizationName",
                            selectedOption.organization_name
                          );
                          // setFieldValue("organizationId", selectedOption.id);
                          // setFieldValue("address", selectedOption.address);
                          setFieldValue("street", selectedOption.street);
                          setFieldValue("city", selectedOption.city);
                          setFieldValue("state", selectedOption.state);
                          setFieldValue("zip", selectedOption.zip);
                          setFieldValue("phone", selectedOption.phone);
                          setFieldValue("twitter", selectedOption.twitter);
                          setFieldValue("linkedIn", selectedOption.linkedin);
                          setFieldValue(
                            "subscriber",
                            selectedOption.subscriber
                          );
                          setFieldValue(
                            "subscriberType",
                            selectedOption.subscriberType
                          );
                          console.log("selectedOption", selectedOption);
                          if (selectedOption.fiscal_year) {
                            setFieldValue(
                              "fiscalYear",
                              selectedOption.fiscal_year
                            );
                          }
                          // setFieldValue("fiscalYear", selectedOption.fiscal_year);
                          if (selectedOption.industry) {
                            setFieldValue("industry", selectedOption.industry);
                          }
                          if (selectedOption.other_industry) {
                            setFieldValue(
                              "otherIndustry",
                              selectedOption.other_industry
                            );
                          }
                          setFieldValue("nickName", selectedOption.nick_name);
                          setFieldValue("website", selectedOption.website);
                          setFieldValue("notes", selectedOption.notes);
                        }
                      }}
                      renderOption={(props, option) => (
                        <li {...props} key={option._id}>
                          <Typography>{`${option.organization_name} ${option.street}, ${option.city}, ${option.state}, ${option.phone}`}</Typography>
                        </li>
                      )}
                      renderInput={(params) => (
                        // console.log('params', params)
                        <Field
                          {...params}
                          as={TextField}
                          fullWidth
                          label="Organization Name"
                          name="organizationName"
                          variant="outlined"
                        />
                      )}
                    />
                    {/* <Field
                      as={TextField}
                      fullWidth
                      label="Organization Name"
                      name="organizationName"
                      variant="outlined"
                      error={
                        touched.organizationName && !!errors.organizationName
                      }
                      helperText={<ErrorMessage name="organizationName" />}
                    /> */}
                  </Grid2>
                  
                  {/** Organization users **/}
                  {/* Multi-select user dropdown */}
                  {
                    isSelectedOrg && orgUserList && orgUserList.length > 0 &&
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <Autocomplete
                        multiple
                        id="user-multi-select"
                        options={orgUserList}
                        disableCloseOnSelect
                        getOptionLabel={(option) =>
                          `${option.first_name} ${option.last_name}`
                        }
                        onChange={(event, value) => setSelectedUsers(value)}
                        isOptionEqualToValue={(option, value) =>
                          option._id === value._id
                        }
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            style={{ border: "1px solid #cdcdcdc4" }}
                          >
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <Avatar
                              src={ `${process.env.REACT_APP_VPMA_FRONTEND_URL}/profile-image/${option.profile_image}`}
                              alt={`${option.first_name} ${option.last_name}`}
                              sx={{ width: 24, height: 24, mr: 1 }}
                            />
                            <Typography variant="body2">
                              {option.first_name} {option.last_name}
                            </Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="user-select-drop"
                            variant="outlined"
                            label="Select Users"
                            placeholder="Choose users"
                          />
                        )}
                        value={selectedUsers}
                      />
                    </Grid2>
                  }

                  {/** Street **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Street"
                      name="street"
                      variant="outlined"
                    />
                  </Grid2>

                  {/** City **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="City"
                      name="city"
                      variant="outlined"
                    />
                  </Grid2>

                  {/** State **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    {/* <Field
                      as={TextField}
                      fullWidth
                      label="State"
                      name="state"
                      variant="outlined"
                    /> */}
                    <Autocomplete
                      sx={{
                        '& .MuiInputBase-root': {
                          height: '50px !important',
                        },
                      }}
                      options={usStates}
                      autoHighlight
                      value={values.state}
                      onChange={(event, newValue) => {
                        setFieldValue("state", newValue || "");
                      }}
                      onBlur={handleBlur}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="state"
                          label="State"
                          variant="outlined"
                          fullWidth
                          className="user-select-drop"
                          error={touched.state && !!errors.state}
                          helperText={<ErrorMessage name="state" />}
                        />
                      )}
                    />
                  </Grid2>

                  {/** Zip Code **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Zip Code"
                      name="zip"
                      variant="outlined"
                      error={touched.zip && !!errors.zip}
                      helperText={<ErrorMessage name="zip" />}
                    />
                  </Grid2>

                  {/** Phone **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Phone"
                      name="phone"
                      variant="outlined"
                      error={touched.phone && !!errors.phone}
                      helperText={<ErrorMessage name="phone" />}
                    />
                  </Grid2>

                  {/** Twitter **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Twitter"
                      name="twitter"
                      variant="outlined"
                    />
                  </Grid2>

                  {/** LinkedIn **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="LinkedIn"
                      name="linkedIn"
                      variant="outlined"
                    />
                  </Grid2>

                  {/** File Upload (Profile Image) **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <label htmlFor="logo">Upload logo</label>
                    <input
                      type="file"
                      name="orgLogo"
                      className="form-control"
                      onChange={(event) =>
                        setFieldValue("orgLogo", event.currentTarget.files[0])
                      }
                    />
                  </Grid2>

                  {/* Subscriber Type Dropdown */}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <FormControl
                      fullWidth
                      error={touched.subscriberType && !!errors.subscriberType}
                    >
                      <InputLabel id="subscriberType-label">
                        Subscriber Type
                      </InputLabel>
                      <Field
                        as={Select}
                        labelId="subscriberType-label"
                        id="subscriberType"
                        name="subscriberType"
                        label="Subscriber Type"
                      >
                        {subscriberTypeList.map((option) => (
                          <MenuItem key={option.id} value={option.value}>
                            {option.type}
                          </MenuItem>
                        ))}
                      </Field>
                      <FormHelperText>
                        <ErrorMessage name="subscriberType" />
                      </FormHelperText>
                    </FormControl>
                  </Grid2>

                  {/* Fiscal Year Dropdown */}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <FormControl
                      fullWidth
                      error={touched.fiscalYear && !!errors.fiscalYear}
                    >
                      <InputLabel id="fiscalYear-label">Fiscal Year</InputLabel>
                      <Field
                        as={Select}
                        labelId="fiscalYear-label"
                        id="fiscalYear"
                        name="fiscalYear"
                        label="Fiscal Year"
                      >
                        {months.map((month, index) => (
                          <MenuItem key={index} value={month}>
                            {month}
                          </MenuItem>
                        ))}
                      </Field>
                      <FormHelperText>
                        <ErrorMessage name="fiscalYear" />
                      </FormHelperText>
                    </FormControl>
                  </Grid2>

                  {/* Industry Dropdown */}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <FormControl
                      fullWidth
                      error={touched.industry && !!errors.industry}
                    >
                      <InputLabel id="industry-label">Industry</InputLabel>
                      <Field
                        as={Select}
                        labelId="industry-label"
                        id="industry"
                        name="industry"
                        label="Industry"
                      >
                        {industries.map((industry, index) => (
                          <MenuItem key={index} value={industry}>
                            {industry}
                          </MenuItem>
                        ))}
                      </Field>
                      <FormHelperText>
                        <ErrorMessage name="industry" />
                      </FormHelperText>
                    </FormControl>
                  </Grid2>

                  {values.industry == "Others" && (
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <Field
                        as={TextField}
                        fullWidth
                        label="Other industry"
                        name="otherIndustry"
                        variant="outlined"
                      />
                    </Grid2>
                  )}

                  {/** Nickname **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Nickname"
                      name="nickName"
                      variant="outlined"
                      error={touched.nickName && !!errors.nickName}
                      helperText={<ErrorMessage name="nickName" />}
                    />
                  </Grid2>

                  {/** Website **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Website"
                      name="website"
                      variant="outlined"
                      error={touched.website && !!errors.website}
                      helperText={<ErrorMessage name="website" />}
                    />
                  </Grid2>

                  {/** Purchase Date **/}
                  {/* <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      type="date"
                      label="Purchase Date"
                      name="purchaseDate"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      error={Boolean(
                        touched.purchaseDate && errors.purchaseDate
                      )}
                      helperText={
                        touched.purchaseDate && errors.purchaseDate
                          ? errors.purchaseDate
                          : ""
                      }
                    />
                  </Grid2> */}

                  {/** Video Package **/}
                  {/* <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      type="Number"
                      min={0}
                      label="Video Package"
                      name="videoPackage"
                      variant="outlined"
                      error={touched.videoPackage && !!errors.videoPackage}
                      helperText={<ErrorMessage name="videoPackage" />}
                    />
                  </Grid2> */}

                  {/** Notes **/}
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Field
                      as={TextField}
                      fullWidth
                      label="Notes"
                      name="notes"
                      variant="outlined"
                      error={touched.notes && !!errors.notes}
                      helperText={<ErrorMessage name="notes" />}
                    />
                  </Grid2>
                </Grid2>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    justifyContent: "start",
                    mt: 4,
                  }}
                >
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={!isValid || isSubmitting}
                  >
                    {isSubmitting ? "Creating..." : "Create"}
                  </Button>
                  <Button variant="contained" onClick={()=>{navigate('/organization/list')}}>Cancel</Button>
                  {/* <Button variant='contained' onClick={() => { handleCancel() }}>Cancel</Button> */}
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{ padding: "20px 20px" }}>
            <Typography variant="h2">Create Follow-Up Task</Typography>
          </Box>
          <Divider />
          <Box sx={{ padding: "10px 20px" }}>
            <Box>
              <Formik
                initialValues={{
                  selectTeamMember: selectedTaskDetails.selectTeamMember
                    ? selectedTaskDetails.selectTeamMember
                    : "",
                  startDate: selectedTaskDetails.startDate
                    ? selectedTaskDetails.startDate
                    : "",
                }}
                validationSchema={followUpValidation}
                onSubmit={(values, { setSubmitting }) => {
                  console.log("Form Data:", values);
                  setIsSubmitting(true);
                  // setSubmitting(false);
                  handleFollowUpTask(values);
                }}
              >
                {({
                  values,
                  setFieldValue,
                  handleChange,
                  handleBlur,
                  isValid,
                  errors,
                  touched,
                }) => (
                  <Form>
                    <Typography id="select-team-label">Select Team</Typography>
                    <FormControl
                      sx={{ marginBottom: "30px", marginTop: "10px" }}
                      fullWidth
                      error={
                        touched.selectTeamMember && !!errors.selectTeamMember
                      }
                    >
                      <Field
                        as={Select}
                        id="selectTeamMember"
                        value={values.selectTeamMember}
                        name="selectTeamMember"
                      >
                        {followUpTeam.map((option) => (
                          <MenuItem key={option._id} value={option._id}>
                            {`${option.firstName} ${option.lastName}`}
                          </MenuItem>
                        ))}
                      </Field>
                      <FormHelperText>
                        <ErrorMessage name="selectTeamMember" />
                      </FormHelperText>
                    </FormControl>
                    <Stack direction={"row"} alignItems={"center"} gap={2}>
                      <Typography>Follow Up Date:</Typography>
                      <DatePicker
                        selected={values.startDate}
                        minDate={moment().toDate()}
                        dateFormat="d MMMM yyyy"
                        onChange={(date) => setFieldValue("startDate", date)}
                        customInput={<CustomButton />}
                        value={values.startDate}
                      />
                      <FormHelperText>
                        <ErrorMessage name="startDate" />
                      </FormHelperText>
                    </Stack>
                    <Stack
                      direction={"row"}
                      justifyContent={"end"}
                      gap={2}
                      mr={2}
                      mb={3}
                    >
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={!isValid || isSubmittingFollowUp}
                      >
                        {isSubmittingFollowUp ? "Saving..." : "Save"}
                      </Button>
                      <Button variant="contained" onClick={handleClose}>
                        Cancel
                      </Button>
                    </Stack>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default CreateOrganization;
